/**
 * ErrorState.js
 *
 * Component displayed when an error occurs
 */

import React from 'react';
import './Shared.css';

/**
 * ErrorState Component
 *
 * Props:
 * - error: Error message or object
 * - onRetry: Retry handler (optional)
 * - icon: Custom icon (optional)
 * - className: Additional CSS classes
 */
const ErrorState = ({
  error = 'An error occurred',
  onRetry = null,
  icon = '⚠️',
  className = ''
}) => {
  const errorMessage =
    typeof error === 'string' ? error : error?.message || 'An unexpected error occurred';

  return (
    <div className={`error-state ${className}`}>
      <div className="error-icon">{icon}</div>
      <h3 className="error-title">Error</h3>
      <p className="error-message">{errorMessage}</p>
      {onRetry && (
        <button className="error-retry-btn" onClick={onRetry}>
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorState;
